var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4853_1939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1435 5.43708C23.3085 5.80708 22.4115 6.05708 21.4685 6.17008C22.4415 5.58787 23.1694 4.67154 23.5165 3.59208C22.6023 4.13507 21.6018 4.51727 20.5585 4.72208C19.8569 3.97294 18.9276 3.4764 17.9148 3.30955C16.9021 3.1427 15.8626 3.31487 14.9577 3.79933C14.0529 4.28379 13.3333 5.05344 12.9107 5.98878C12.488 6.92412 12.386 7.97283 12.6205 8.97208C10.7682 8.87907 8.95613 8.39763 7.30192 7.55898C5.64772 6.72034 4.18834 5.54324 3.0185 4.10408C2.6185 4.79408 2.3885 5.59408 2.3885 6.44608C2.38805 7.21307 2.57693 7.96832 2.93838 8.64481C3.29982 9.3213 3.82266 9.89812 4.4605 10.3241C3.72078 10.3005 2.99737 10.1007 2.3505 9.74108V9.80108C2.35043 10.8768 2.72253 11.9195 3.40368 12.7521C4.08483 13.5847 5.03307 14.156 6.0875 14.3691C5.40128 14.5548 4.68184 14.5822 3.9835 14.4491C4.281 15.3747 4.8605 16.1841 5.64087 16.764C6.42124 17.3439 7.36342 17.6653 8.3355 17.6831C6.68533 18.9785 4.64739 19.6812 2.5495 19.6781C2.17788 19.6782 1.80658 19.6565 1.4375 19.6131C3.56698 20.9823 6.04584 21.7089 8.5775 21.7061C17.1475 21.7061 21.8325 14.6081 21.8325 8.45208C21.8325 8.25208 21.8275 8.05008 21.8185 7.85008C22.7298 7.19105 23.5164 6.37497 24.1415 5.44008L24.1435 5.43708Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4853_1939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ed26c20d6dd36c5e1f16eaf07899f06f.svg";
export { ForwardRef as ReactComponent };